<template lang="pug">
div.animated.fadeIn
  b-row#home
    b-col(md='3')
      b-link(to='interactions/live')
        b-card.text-center
          h6.card-title.my-3
            i.fa.fa-commenting
            br
            | Live
    b-col(md='3')
      b-link(to='interactions/historical')
        b-card.text-center
          h6.card-title.my-3
            i.icon-book-open
            br
            | Historical
</template>

<script>

export default {
  name: 'dashboard',
  data() {
    return {
      userAccessLevel: this.$store.state.profile.accessLevel,
      navs: {},
    }
  },
  methods: {
    // User Chat Link
    chatLink (value) {
      return '/interactions/' + value.toLowerCase().replace(' ', '-')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/InteractionMenu.vue?5dcf6e2e